module.exports = __webpack_public_path__ + "img/Zug_für_Soziale_Betreuung.7a4a1206.svg";